// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dFw40","top":"styles_top__1_iwg"};